<template>
  <div class="relative flex flex-col items-center bg-blue px-4 py-16 text-center lg:py-32">
    <LogoHalf styles="absolute inset-y-0 left-0 hidden h-full lg:block" />
    <LogoHalf styles="absolute inset-y-0 right-0 hidden h-full lg:block" position="right" />
    <Logo class="mb-8 lg:hidden" />
    <SubTitle class="text-white">{{ data?.subtitle }}</SubTitle>
    <h3
      class="mb-6 font-serif text-4xl font-bold leading-none text-white lg:mb-8 lg:max-w-screen-lg lg:text-6xl"
    >
      {{ data?.title }}
    </h3>
    <div
      class="mb-8 font-sans text-base leading-snug text-white lg:mb-14 lg:max-w-screen-sm lg:text-lg lg:leading-snug"
      v-html="data?.copy"
    ></div>
    <Link
      v-if="data?.link?.url"
      :title="data.link.title"
      color="pink"
      class="w-4/5 lg:w-auto"
      :link="data.link.url"
      :external="data?.link?.type === 'ext'"
    />
  </div>
</template>

<script setup lang="ts">
import Logo from '../atoms/Icons/Logo.vue'
import Link from '../atoms/Link.vue'
import LogoHalf from '../atoms/Icons/LogoHalf.vue'
import SubTitle from '../atoms/SubTitle.vue'
import type { ILinkData } from '../../types'

export interface ICTABannerBlock {
  id: string
  title?: string
  subtitle?: string
  copy?: string
  link?: ILinkData
}

interface Props {
  data: ICTABannerBlock
}

defineProps<Props>()
</script>
